const bookingTripCategory = 'Booking Trip';
const bookingTripAction = 'Clicked';
const bookingTripLabel = 'Go to Navimag Tickets';

export { bookingTripAction, bookingTripCategory, bookingTripLabel };
